import React, { useState } from "react";

export default function AddFarmer() {
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phone: "",
        address: "",
        location: null,
    });

    const [errors, setErrors] = useState({});

    // Handle input change
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    // Validate inputs
    const validateInputs = () => {
        const errors = {};
        if (!formData.name.trim()) errors.name = "Name is required";
        if (!formData.email.trim() || !/\S+@\S+\.\S+/.test(formData.email))
            errors.email = "Valid email is required";
        if (!formData.phone.trim() || !/^\d+$/.test(formData.phone))
            errors.phone = "Valid phone number is required";
        if (!formData.address.trim()) errors.address = "Address is required";
        if (!formData.location) errors.location = "Location must be selected on the map";
        setErrors(errors);
        return Object.keys(errors).length === 0;
    };

    // Handle form submission
    const handleSubmit = () => {
        if (validateInputs()) {
            console.log("Form submitted:", formData);
            // Add submission logic here
        }
    };

    // Mock map select handler
    const handleMapSelect = (location) => {
        setFormData({ ...formData, location });
        setErrors({ ...errors, location: null }); // Clear location error
    };

    return (
        <div className="h-screen">
            <div className="bg-white shadow-lg rounded-lg p-6 max-w-4xl mx-auto">
                <div className="flex flex-col">
                    {/* Header */}
                    <div className="flex flex-row items-center justify-between p-4 bg-gray-200 rounded-t-lg">
                        <h3 className="font-semibold text-lg text-gray-700">New Farmer</h3>
                        <button
                            className="text-lightBlue-500 bg-transparent border border-solid border-lightBlue-500 hover:bg-lightBlue-500 hover:text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                            type="button"
                            onClick={handleSubmit}
                        >
                            Save
                        </button>
                    </div>
                    {/* Form */}
                    <form className="p-4 space-y-6">
                        {/* Name */}
                        <div className="relative flex w-full lg:w-1/2 flex-wrap items-stretch mb-3">
                            <span className="z-10 h-full leading-snug font-normal absolute text-center text-blueGray-300 bg-transparent rounded text-base items-center justify-center w-8 pl-2 py-1">
                                <i className="fas fa-user"></i>
                            </span>
                            <input
                                type="text"
                                id="name"
                                name="name"
                                placeholder="Name"
                                className="px-2 py-1 placeholder-blueGray-500 text-gray-700 bg-white rounded border border-blueGray-300 outline-none focus:outline-none focus:shadow-outline w-full pl-10"
                                value={formData.name}
                                onChange={handleInputChange}
                            />
                            {errors.name && <p className="text-red-500 text-xs mt-1">{errors.name}</p>}
                        </div>
                        {/* Email */}
                        <div className="relative flex w-full lg:w-1/2 flex-wrap items-stretch mb-3">
                            <span className="z-10 h-full leading-snug font-normal absolute text-center text-blueGray-300 bg-transparent rounded text-base items-center justify-center w-8 pl-2 py-1">
                                <i className="fas fa-envelope"></i>
                            </span>
                            <input
                                type="email"
                                id="email"
                                name="email"
                                placeholder="Email"
                                className="px-2 py-1 placeholder-blueGray-500 text-gray-700 bg-white rounded text-sm border border-blueGray-300 outline-none focus:outline-none focus:shadow-outline w-full pl-10"
                                value={formData.email}
                                onChange={handleInputChange}
                            />
                            {errors.email && <p className="text-red-500 text-xs mt-1">{errors.email}</p>}
                        </div>
                        {/* Phone */}
                        <div className="relative flex w-full lg:w-1/2 flex-wrap items-stretch mb-3">
                            <span className="z-10 h-full leading-snug font-normal absolute text-center text-blueGray-300 bg-transparent rounded text-base items-center justify-center w-8 pl-2 py-1">
                                <i className="fas fa-phone"></i>
                            </span>
                            <input
                                type="tel"
                                id="phone"
                                name="phone"
                                placeholder="Phone"
                                className="px-2 py-1 placeholder-blueGray-500 text-gray-700 bg-white rounded text-sm border border-blueGray-300 outline-none focus:outline-none focus:shadow-outline w-full pl-10"
                                value={formData.phone}
                                onChange={handleInputChange}
                            />
                            {errors.phone && <p className="text-red-500 text-xs mt-1">{errors.phone}</p>}
                        </div>
                        {/* Address */}
                        <div className="relative flex w-full lg:w-1/2 flex-wrap items-stretch mb-3">
                            <span className="z-10 h-full leading-snug font-normal absolute text-center text-blueGray-300 bg-transparent rounded text-base items-center justify-center w-8 pl-2 py-1">
                                <i className="fas fa-map-marker-alt"></i>
                            </span>
                            <input
                                type="text"
                                id="address"
                                name="address"
                                placeholder="Address"
                                className="px-2 py-1 placeholder-blueGray-500 text-gray-700 bg-white rounded text-sm border border-blueGray-300 outline-none focus:outline-none focus:shadow-outline w-full pl-10"
                                value={formData.address}
                                onChange={handleInputChange}
                            />
                            {errors.address && <p className="text-red-500 text-xs mt-1">{errors.address}</p>}
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}
